(function () {
  var root = document.querySelector('[data-e14x]');
  if (!root || root.dataset.e14xBound === '1') return;
  root.dataset.e14xBound = '1';
  Array.prototype.forEach.call(root.querySelectorAll('.fw-e14x__row'), function (row) {
    var down = false, startX = 0, startScroll = 0, moved = false;
    row.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startScroll = row.scrollLeft;
    });
    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - startX;
      if (!moved && Math.abs(d) < 4) return;
      moved = true;
      row.classList.add('is-dragging');
      row.scrollLeft = startScroll - d;
      e.preventDefault();
    });
    var release = function () {
      if (!down) return;
      down = false;
      window.setTimeout(function () { row.classList.remove('is-dragging'); }, 0);
    };
    row.addEventListener('pointerup', release);
    row.addEventListener('pointerleave', release);
    row.addEventListener('pointercancel', release);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });
  Array.prototype.forEach.call(root.querySelectorAll('.fw-e14x__text'), function (p) {
    if (p.dataset.e14xMore) return;
    p.dataset.e14xMore = '1';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'fw-e14x__more';
    button.textContent = 'Lire plus…';
    p.parentNode.insertBefore(button, p.nextSibling);
    var check = function () {
      if (!p.classList.contains('is-open') && p.scrollHeight > p.clientHeight + 2) button.classList.add('is-visible');
    };
    check();
    window.setTimeout(check, 600);
    button.addEventListener('click', function (ev) {
      ev.stopPropagation();
      var open = p.classList.toggle('is-open');
      button.textContent = open ? 'Réduire' : 'Lire plus…';
    });
  });
})();
